import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';
import { blOrderInvoicesKey } from './use-bl-order-invoices';
import { allocatedDownpaymentKey } from './use-allocated-downpayment';
import type { InvoiceRow } from '../types';

export interface VoidInvoiceMutationArgs {
  readonly invoiceId: string;
  readonly orderId: string;
  readonly blOrderId?: string | undefined;
}

export function useVoidInvoiceMutation(args: VoidInvoiceMutationArgs) {
  const qc = useQueryClient();
  return useMutation<InvoiceRow, Error, string>({
    mutationFn: (void_reason) =>
      apiRequest<InvoiceRow>(`/invoices/${encodeURIComponent(args.invoiceId)}/void`, {
        method: 'POST',
        body: { void_reason },
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['order-advance-invoices', args.orderId] });
      void qc.invalidateQueries({ queryKey: ['order-invoices', args.orderId] });
      if (args.blOrderId !== undefined) {
        void qc.invalidateQueries({ queryKey: blOrderInvoicesKey(args.blOrderId) });
        void qc.invalidateQueries({ queryKey: allocatedDownpaymentKey(args.blOrderId) });
        void qc.invalidateQueries({ queryKey: ['bl-order-detail'] });
      }
    },
  });
}
